import { configure } from 'vee-validate'
import components from './components'
import rules from './rules'
import locales from './locales'

const validations = {
  install(Vue) {
    configure({
      classes: {
        invalid: 'is-invalid',
      }
    })
    Vue.use(components)
    Vue.use(rules)
    Vue.use(locales)
  }
}

export default validations
